import React from 'react';
import appImage from './assets/app.png';
import badgeImage from './assets/badge.png';
import styles from './styles.scss';

function Examples() {
  return (
    <div>
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="text-center">
            <h1>
              How we conquered the app store.
            </h1>
            <p className={`alt-text ls1 ${styles.exampleHeading}`}>
              We partnered with Kevin Jonas of the Jonas brothers to create an
              engaging app for his brother's band DNCE. Read all about it below!
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className={styles.example}>
          <div className={`${styles.exampleCard} ${styles.blue}`}>
            <h1 className="bold">DNCE THE GAME</h1>
            <div className={styles.cardBottom}>
              <a
                href="https://medium.com/designcue/the-importance-of-engaging-a-designer-before-a-developer-f0512f4b601f"
                target="_blank"
                className={`${styles.button} btn btn-dc-primary inverse btn-block`}
              >
                READ ON MEDIUM
              </a>
            </div>
            <img className={styles.badge} src={badgeImage} alt="badge" />
          </div>
          <div className={`${styles.exampleImageContainer} ${styles.rightHand}`}>
            <img src={appImage} alt="DNCE THE GAME" />
          </div>
        </div>
      </div>
      <div className="text-center">
        <a
          href="https://medium.com/designcue/"
          target="_blank"
          className="btn btn-dc-primary btn-xs-block"
        >
          VIEW MORE ON MEDIUM
        </a>
      </div>
    </div>
  );
}

export default Examples;



// WEBPACK FOOTER //
// ./src/components/Examples/index.js